import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AdminTenantGroupService } from '../../../../services/admin-tenant-group.service';
import { ToastService } from '../../../../services/toast-service';

@Component({
  selector: 'app-create-group-modal',
  templateUrl: './create-group-modal.component.html',
  styleUrls: ['./create-group-modal.component.scss']
})
export class CreateGroupModalComponent implements OnInit {
  groupForm!: FormGroup;
  saving = false;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private adminService: AdminTenantGroupService,
    private toastService: ToastService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.groupForm = this.fb.group({
      groupName: ['', [Validators.required, Validators.maxLength(100)]],
      description: ['', Validators.maxLength(500)]
    });
  }

  save(): void {
    if (this.groupForm.invalid) {
      Object.keys(this.groupForm.controls).forEach(key => {
        this.groupForm.controls[key].markAsTouched();
      });
      return;
    }

    this.saving = true;
    const formData = this.groupForm.value;

    this.adminService.createGroup(formData).subscribe({
      next: (response) => {
        if (response?.success) {
          this.activeModal.close('created');
        } else {
          this.toastService.showApiError(response?.errorMessage, this.translateService.instant('TenantGroupManagement.createFailed'));
          this.saving = false;
        }
      },
      error: (error) => {
        console.error('Error creating group:', error);
        this.toastService.show({
          type: 'error',
          data: [this.translateService.instant('TenantGroupManagement.createFailed')]
        });
        this.saving = false;
      }
    });
  }

  cancel(): void {
    this.activeModal.dismiss();
  }
}
